export enum Email {
  SUPPORT = 'help.sxm@salsify.com',
  ONBOARDING = 'supplierxm-onboarding@salsify.com',
  SALES_VIDEO = 'supplierxm-sales@salsify.com',
}
